export const INCIDENT_REPORT_URL = 'https://forms.timelycare.com/241126387914055'
export const DAILY_NETWORK_TEST_URL = 'https://network-test.daily.co/index.html'
